/** @module Specification/CompositionForm */

import declare from "dojo/_base/declare";
import { Field } from "csi/def/Field";
import Widget from "csi/form/Widget";
import { featureTogglesStore } from "csi/state/rootStore";

const CompositionForm = declare(Widget, {
	/**
	 * @override
	 * If "com.centricsoftware.feature.material.composition" feature flag is turned off, hide the "Composition Types" field
	 */
	_buildFields: function(fields: Field[]) {
		this.inherited(arguments);

		const compositionFeatureFlagEnabled = featureTogglesStore.MATERIAL_COMPOSITION;
		this.setFieldHidden("SustainabilityCompositionTypes", !compositionFeatureFlagEnabled);
	},
});

export = CompositionForm;
